"use client";

import { useEffect, useState } from "react";

let cache: Record<string, string> | null = null;
let inflight: Promise<Record<string, string>> | null = null;

function fetchLogoMap(): Promise<Record<string, string>> {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = fetch("/api/reference-data")
      .then((r) => r.json())
      .then((j) => {
        const m = j?.data?.pokerSiteLogoUrls;
        cache =
          m && typeof m === "object" && !Array.isArray(m)
            ? (m as Record<string, string>)
            : {};
        return cache;
      })
      .catch(() => {
        cache = {};
        return cache;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** Invalider le cache après un upload admin (même onglet). */
export function invalidatePokerSiteAdminLogoCache() {
  cache = null;
}

/** URL publique du logo admin pour ce nom de site, ou null si aucun. */
export function usePokerSiteAdminLogo(siteName: string): string | null | undefined {
  const [url, setUrl] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    fetchLogoMap().then((m) => {
      if (!cancelled) setUrl(m[siteName] ?? null);
    });
    return () => {
      cancelled = true;
    };
  }, [siteName]);

  return url;
}
